import React from "react";
import SkillCard from "./SkillCard";
import { SkillGroup } from "../data/portfolio";

interface SkillSectionProps {
  skillGroup: SkillGroup;
}

const SkillSection: React.FC<SkillSectionProps> = ({ skillGroup }) => {
  return (
    <div className="flex flex-col flex-1">
      <div className="h-[40px] flex items-center justify-center mb-4">
        <h3 className="text-xl md:text-lg lg:text-xl text-center">{skillGroup.title}</h3>
      </div>
      <div className={`grid grid-cols-4 md:grid-cols-2 lg:grid-cols-4 gap-4 flex-1 ${skillGroup.hasBorder ? 'pb-6 border-b' : ''}`}>
        {skillGroup.skills.map((skill, index) => (
          <SkillCard key={index} skill={skill} />
        ))}
      </div>
    </div>
  );
};

export default SkillSection;